import { render } from "./revoked.vue?vue&type=template&id=27b4c249&scoped=true"
import script from "./revoked.vue?vue&type=script&lang=js"
export * from "./revoked.vue?vue&type=script&lang=js"

import "./revoked.vue?vue&type=style&index=0&id=27b4c249&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b4c249"]])

export default __exports__